import Vue from 'vue'

import '@/assets/index'
import SvgIcon from '@/components/icon'
Vue.component('svg-icon', SvgIcon)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
